import { IBaseGetParams } from './global.model'
import { IBaseReducer } from './base-reducer.model'

export interface INotificationPreference {
  notification_type_id: number
  notification_type_name: string
  notification_type_description: string
  notification_channel_id: number
  notification_channel_name: string
  notification_type_position: number
  id: number
  status: 1
  is_editable: boolean
  notification_type?: INotificationType
  notification_channel?: INotificationChannel
}

type NotificationPreferenceChannel = Pick<
  INotificationPreference,
  | 'id'
  | 'notification_channel_id'
  | 'notification_channel_name'
  | 'notification_type_position'
  | 'status'
  | 'is_editable'
>

export interface IGroupedNotificationPreference {
  notification_type_id: INotificationPreference['notification_type_id']
  notification_type_name: INotificationPreference['notification_type_name']
  notification_type_description: INotificationPreference['notification_type_description']
  email: NotificationPreferenceChannel
  text: NotificationPreferenceChannel
  push: NotificationPreferenceChannel
}

export interface INotificationType {
  description: string
  id: number
  name: string
  status: number
}

export interface INotificationChannel {
  description: string
  id: number
  name: string
  status: number
}

export interface IGetNotificationPreferencesParams extends IBaseGetParams {
  status?: number
  user_id?: number
  role_id?: number
}

export interface IPostNotificationPreferenceParams {
  notification_channel_id: number
  notification_type_id: number
  status?: number
}

export type IPutNotificationPreferenceParams = INotificationPreferenceIncludeParams &
  IPutNotificationPreferenceParamsBase

export interface IPutNotificationPreferenceParamsBase {
  status: number
}

export interface INotificationPreferenceIncludeParams {
  include?:
    | {
        notification_type?: Record<any, any>
        notification_channel?: Record<any, any>
      }
    | ('notification_type' | 'notification_channel')[]
}

export interface INotificationPreferenceReducer
  extends IBaseReducer<INotificationPreference[]> {
  notificationPreference?: INotificationPreference
}

export enum NOTIFICATION_CHANNEL_NAME {
  TEXT = 'Text',
  SMS = 'Sms',
  EMAIL = 'Email',
  PUSH = 'Push',
}

export enum NOTIFICATION_PREFERENCE_STATUS {
  DISABLED,
  ENABLED,
}
